import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Graphics } from '@pixi/react';
import BoostedJackpotInitialPopupView from './boostedJackpotInitialPopupView';
import { userSettingsStore } from '../../../../store/userSettingsStore';
import { isMobile } from '../../../../core/helpers/isMobile';
import { applicationStore } from '../../../../store/applicationStore';
import { bettingPartStore } from '../../../../store/bettingPartStore';
import { boostedJackpotStore } from '../../../../store/boostedJackpotStore';
import { textureChangeFrame } from '../../../../core/helpers/textureChangeFrame';

const BoostedJackpotInitialPopup = observer(
  ({
    boostedJackpotInitialPopup,
    boostedJackpotPopupCloseButton,
    boostedJackpotInfoPopupOkButton,
    boostedJackpotInfoPopupOkButtonHover,
    boostedJackpotInfoPopupOkButtonPressed,
    containerConfigBoostedJackpotInitialPopup,
  }) => {
    const { setIsShowBlackLayer } = applicationStore;
    const { updateSelectedQuickBet, quickBets } = bettingPartStore;
    const { boostedInitialBetAmount, setBoostedBetAmount } = boostedJackpotStore;
    const { isBoostedJackpotInitialPopup, updateIsBoostedJackpotInitialPopup } = userSettingsStore;

    const handleClickButtons = useCallback(
      (isShowBoostBetAmount) => {
        if (isShowBoostBetAmount) {
          const validQuickBet = quickBets.find((el) => el >= boostedInitialBetAmount);
          setBoostedBetAmount(validQuickBet);
          updateSelectedQuickBet(validQuickBet);
        } else {
          setBoostedBetAmount(null);
        }
        updateIsBoostedJackpotInitialPopup();
      },
      [
        quickBets,
        setBoostedBetAmount,
        updateSelectedQuickBet,
        boostedInitialBetAmount,
        updateIsBoostedJackpotInitialPopup,
      ]
    );

    const handlePointerOut = useCallback(
      (e) => {
        textureChangeFrame(e.target.children[0], boostedJackpotInfoPopupOkButton);
      },
      [boostedJackpotInfoPopupOkButtonPressed]
    );

    const handlePointerMove = useCallback(
      (e) => {
        textureChangeFrame(e.target.children[0], boostedJackpotInfoPopupOkButtonHover);
      },
      [boostedJackpotInfoPopupOkButtonHover]
    );
    const handlePointerDown = useCallback(
      (e) => {
        textureChangeFrame(e.target.children[0], boostedJackpotInfoPopupOkButtonPressed);
      },
      [boostedJackpotInfoPopupOkButtonHover]
    );

    useEffect(() => {
      if (isBoostedJackpotInitialPopup && isMobile()) {
        setIsShowBlackLayer(true);
      } else {
        setIsShowBlackLayer(false);
      }
    }, [setIsShowBlackLayer, isBoostedJackpotInitialPopup]);

    if (!isBoostedJackpotInitialPopup) {
      return;
    }
    // eslint-disable-next-line consistent-return
    return (
      <>
        {!isMobile() && (
          <Graphics
            draw={(g) => {
              g.clear();
              g.alpha = 0.7;
              g.beginFill(0x030303);
              g.drawRect(0, 0, 1440, 860);
              g.interactive = true;
            }}
          />
        )}
        <Container name='BoostedJackpotInitialPopup' {...containerConfigBoostedJackpotInitialPopup}>
          <BoostedJackpotInitialPopupView
            handlePointerOut={handlePointerOut}
            handlePointerMove={handlePointerMove}
            handlePointerDown={handlePointerDown}
            handleClickButtons={handleClickButtons}
            boostedJackpotInitialPopup={boostedJackpotInitialPopup}
            boostedJackpotPopupCloseButton={boostedJackpotPopupCloseButton}
            boostedJackpotInfoPopupOkButton={boostedJackpotInfoPopupOkButton}
          />
        </Container>
      </>
    );
  }
);

export default BoostedJackpotInitialPopup;
